<template>
    <div>
        <div class="action-header">
            <div class="search-container">
                <div class="search-input">
                    <v-text-field
                        v-model="search"
                        prepend-inner-icon="search"
                        :placeholder="this.$vuetify.lang.t('$vuetify.userManagement.searchText')"
                        solo
                        height="40px"
                        @keyup.enter="searchUser()">
                    </v-text-field>
                </div>

                <div class="ml-3">
                    <v-btn
                        height="40px"
                        color="primary"
                        outlined
                        @click="searchUser()">
                        {{ $vuetify.lang.t('$vuetify.userManagement.search') }}
                    </v-btn>
                </div>
            </div>
            <div>
                <v-btn
                    v-if="canUpdate"
                    height="40px"
                    @click="createNewMember()"
                    color="primary"> + {{ $vuetify.lang.t('$vuetify.userManagement.create') }} </v-btn>
            </div>
        </div>
        <v-card class="content-container">
            <v-data-table
                :footer-props="{
                    'items-per-page-options': [10, 20, 30, 50, 100]
                }"
                @page-count="pageCount = $event"
                :page.sync="page"
                :headers="headers"
                :options.sync="options"
                :server-items-length="totalUser"
                :items="users"
                :loading="loading">
                <template v-slot:[`item.action`]="{ item }">
                    <div class="action" v-if="canUpdate">
                        <i
                            class="far fa-edit mr-3"
                            @click.stop="goToEditUserByAdmin(item.user_id)">
                        </i>
                        <i
                            class="far fa-trash-alt"
                            @click.stop="openDeleteUserModal(item)">
                        </i>
                    </div>
                </template>
            </v-data-table>
        </v-card>
        <div class="pt-2 paginator-box">
            <div>
                <v-pagination v-model="page" :length="pageCount"></v-pagination>
            </div>
        </div>

        <delete-modal
            ref="modalDelete"
            @success-deleted="deleteSuccess()"
            :deleteForm="deleteForm"/>
    </div>
</template>

<script>
import DeleteModal from '@/components/modal/DeleteModal.vue'
export default {
    name: 'UserManagement',

    components: {
        DeleteModal
    },

    data () {
        return {
            search: '',
            pageCount: 1,
            page: 1,
            options: {},
            loading: false,
            totalUser: 0,
            deleteForm: {
                header: this.$vuetify.lang.t('$vuetify.userManagement.deleteUser'),
                content: '',
                path: ''
            },
            users: [],
            canUpdate: false
        }
    },

    computed: {
        headers () {
            return [
                { text: this.$vuetify.lang.t('$vuetify.userManagement.employeeId'), value: 'employee_id', width: '20%' },
                { text: this.$vuetify.lang.t('$vuetify.userManagement.employeeName'), value: 'name', width: '17%' },
                { text: this.$vuetify.lang.t('$vuetify.userManagement.username'), value: 'user__username', width: '40%' },
                { text: this.$vuetify.lang.t('$vuetify.userManagement.phoneNumber'), value: 'phone_number', width: '15%' },
                { text: this.$vuetify.lang.t('$vuetify.userManagement.action'), value: 'action', width: '8%', sortable: false }
            ]
        }
    },

    methods: {
        async searchUser () {
            this.options.page = 1
            await this.getUsers()
        },

        async getUsers () {
            this.loading = true
            const { sortBy, sortDesc, page, itemsPerPage } = this.options

            let url = `users?page=${page}&itemsPerPage=${itemsPerPage}`

            if (sortBy[0]) {
                url += `&sortBy=${sortBy[0]}`
            }

            if (sortDesc[0]) {
                url += `&sortDesc=${sortDesc[0]}`
            }

            if (this.search) {
                url += `&search=${this.search}`
            }

            const res = await this.axios.get(url)
            if (res && res.data && res.data.status === 'ok') {
                this.users = res.data.data
                this.totalUser = res.data.total
                this.loading = false
            }
        },

        createNewMember () {
            this.$router.push({ name: 'UserForm' }, () => {})
        },

        goToEditUserByAdmin (id) {
            this.$router.push({ name: 'UserForm', params: { id } }, () => {})
        },

        openDeleteUserModal (user) {
            this.deleteForm.content = `${this.$vuetify.lang.t('$vuetify.userManagement.wantToDelete')} "${user.user__username}"? `
            this.deleteForm.path = `user/delete/${user.user_id}`
            this.$refs.modalDelete.dialog = true
        },

        async deleteSuccess () {
            await this.getUsers()
            this.$notify({
                title: this.$vuetify.lang.t('$vuetify.userManagement.congratulation'),
                text: this.$vuetify.lang.t('$vuetify.userManagement.userIsDeleted'),
                type: 'success'
            })
        }
    },

    async mounted () {
        this.canUpdate = await this.hasPermission(this.$constant.permission.COMPANY_SETTING.UPDATE)
    },

    watch: {
        options: {
            async handler () {
                await this.getUsers()
            },
            deep: true
        },
        '$vuetify.lang.current': {
            async handler () {
                await this.getUsers()
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
.search-container {
    ::v-deep .v-input__control > .v-input__slot {
        min-height: auto !important;
        display: flex !important;
        align-items: center !important;
        box-shadow: none !important;
        border: 1px solid #a8a8a8 !important;
        width: 280px;
    }
}
</style>
